import { Tree, Radio } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { FileOutlined } from '@ant-design/icons'
import sessionApi from '../../api/sessionApi'
import useGetWithContext from '../../hooks/useGetWithContext'

const ModalMaterial = ({ folderId = null }) => {
  if (!folderId) {
    return (
      <div
        style={{ height: '400px' }}
      >
        <h2 className='pt-3'>Không có dữ liệu!</h2>
      </div>
    )
  }
  const { DirectoryTree } = Tree
  const [selectedKeys, setSelectedKeys] = useState([])
  const [expandedKeys, setExpandedKeys] = useState([])
  const [selectedFile, setSelectedFile] = useState(null)
  const { data: folder } = useGetWithContext(`GET_FOLDER_BY_ID_${folderId}`, sessionApi.getFolder, folderId, { isDisabled: !folderId })
  const showFileRef = useRef(null)
  const [folderHeight, setFolderHeight] = useState(0)

  useEffect(() => {
    if (showFileRef.current) {
      setFolderHeight(showFileRef.current.offsetHeight)
    }
  }, [])

  const convertFolderToTreeData = (folder) => {
    if (!folder) return []

    const convertNode = (node) => {
      const treeNode = {
        title: node.name,
        key: node.id,
        isLeaf: node?.type === 'FILE',
        icon: node?.type === 'FILE'
          ? <span />
          : <img
            src='/image/folder.png' alt='folder'
            style={{ width: 18, height: 18 }}
          />,
        data: node
      }

      if (node.subFolders && node.subFolders.length > 0) {
        treeNode.children = node.subFolders.map(convertNode)
      }

      return treeNode
    }

    // Tạo node gốc từ folder
    const rootNode = convertNode(folder)
    return [rootNode]
  }

  const treeData = convertFolderToTreeData(folder)
  const onSelect = (keys, info) => {
    setSelectedKeys(keys)
    // Lấy thông tin file được chọn
    if (info.node.data?.fileDriveId && info.node.data?.type === 'FILE') {
      setSelectedFile(info.node.data)
    } else {
      setSelectedFile(null)
    }
  }

  const onExpand = (keys, info) => {
    setExpandedKeys(keys)
    console.log('Trigger Expand', keys, info)
  }

  // Custom title render function to include radio button and icon file
  const titleRender = (nodeData) => {
    const isSelected = selectedKeys.includes(nodeData.key)
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {nodeData.isLeaf && (
          <>
            <Radio checked={isSelected} style={{ marginRight: 4 }} />
            <FileOutlined style={{ marginRight: 8 }} />
          </>
        )}
        <span>{nodeData.title}</span>
      </div>
    )
  }

  // Set expandedKeys khi có folder
  useEffect(() => {
    if (folder) {
      setExpandedKeys([folder.id])
    }
  }, [folder])

  // Render iframe dựa vào loại file
  const renderFilePreview = () => {
    if (!selectedFile) return null

    const { fileDriveId, fileType } = selectedFile
    switch (fileType) {
      case ('pptx'):
        return (
          <>
            <div
              style={{
                position: 'absolute',
                right: '8px',
                bottom: '14px',
                width: 180,
                height: '30px',
                background: 'transparent',
                zIndex: 10
              }}
            />
            <iframe
              src={`https://docs.google.com/presentation/d/${fileDriveId}/embed`}
              frameBorder='0'
              width='960'
              height='569'
              sandbox='allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox'
              allowFullScreen
            />
          </>

        )
      default:
        return (
          <>
            <div
              style={{
                position: 'absolute',
                right: '8px',
                top: '8px',
                width: 180,
                height: '100px',
                background: 'transparent',
                zIndex: 10
              }}
            />
            <iframe
              src={`https://drive.google.com/file/d/${fileDriveId}/preview`}
              width='640'
              height='480'
              allow='autoplay'
              allowFullScreen
            />
          </>
        )
    }
  }
  return (
    <div
      className='d-flex folder-container'
    >
      <DirectoryTree
        multiple={false}
        expandedKeys={expandedKeys}
        onSelect={onSelect}
        onExpand={onExpand}
        treeData={treeData}
        titleRender={titleRender}
        style={{
          width: '100%',
          height: folderHeight || 'auto', // Đặt chiều cao cho cột folder
          overflow: 'auto'
        }}
        showIcon
      />
      <div
        className='flex-fill show-file border position-relative'
        ref={showFileRef}
        style={{
          padding: '8px'
        }}
      >
        {renderFilePreview()}
      </div>
    </div>
  )
}

export default ModalMaterial
